import { IFieldLangMap } from '@patsnap/synapse_common_interface'

export const SINGLE_OR_MULTI_LANG: IFieldLangMap = {
  multiple_drugs: {
    cn: '联合',
    en: 'Combo',
    jp: '併用',
  },
  single_drug: {
    cn: '单药',
    en: 'Mono',
    jp: '単剤',
  },
  'N/A': {
    cn: 'N/A',
    en: 'N/A',
    jp: 'N/A',
  },
}

export const CT_RESULT_DATA_SOURCE_LANG: IFieldLangMap = {
  LITERATURE: { en: 'Literature', jp: '文献', cn: '文献' },
  CTGOV: { en: 'ClinicalTrials.gov', jp: 'ClinicalTrials.gov', cn: 'CTgov官网' },
}

export const CT_RESULT_SPONSOR_EMP_NUM: Record<number, string> = {
  1: '< 10',
  2: '10-100',
  3: '100-500',
  4: '> 500',
}
